import React from "react";
import "react-intl";
import { errorMessages } from "../../intl/shared-resources/serverResponse.js";
import "@mui/material";
import "./ErrorAccordion.js";
import "./ErrorDetails.js";
import "./localize.js";
import "./ErrorModal.js";
import { CodeErrorMessage } from "./CodeErrorMessage.js";
const errorCodeMapping = {
  401: {
    message: errorMessages.notAuthorized
  },
  403: {
    message: errorMessages.notEnoughPermissions
  },
  404: {
    message: errorMessages.notFound
  },
  409: {
    message: errorMessages.conflict
  },
  500: {
    message: errorMessages.unhandledServerError
  },
  502: {
    message: errorMessages.notAvailable
  },
  10000006: {
    message: errorMessages.inputValidationIncorrectFormat
  },
  10000027: {
    message: errorMessages.inputValidationValueNotExist,
    rank: 1
  },
  10000028: {
    message: errorMessages.inputValidationNullValue,
    rank: 1
  },
  10000048: {
    message: errorMessages.invalidNotificationContractType,
    rank: 1
  },
  10000050: {
    message: errorMessages.unexpectedTransactionStatus,
    rank: 1
  },
  10000056: {
    message: errorMessages.transactionWithSameIdAlreadyExists,
    rank: 1
  },
  10000058: {
    message: errorMessages.handledExceptionOccurred,
    rank: 1
  },
  10000062: {
    message: errorMessages.notEnoughFunds,
    rank: 1
  },
  20000001: {
    message: errorMessages.fieldUndefinedValidationError,
    rank: 1
  },
  20000080: {
    message: errorMessages.notInP2PChannel,
    rank: 1
  }
};
function GlobalServerErrorMessage({ error, errorsToShow = "allHighestRanked", hasError }) {
  return /* @__PURE__ */ React.createElement(
    CodeErrorMessage,
    {
      error,
      errorCodeMessages: errorCodeMapping,
      defaultErrorMessage: errorMessages.defaultError,
      errorsToShow,
      hasError
    }
  );
}
export {
  GlobalServerErrorMessage
};
//# sourceMappingURL=GlobalServerErrorMessage.js.map
